import styled from 'styled-components'

export const ChooseTemplateContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: auto;
`
